var map = {
	"./13.svg": "5157",
	"./14.svg": "8d05",
	"./18.svg": "e752",
	"./21.svg": "c812",
	"./22.svg": "cf0b",
	"./26.svg": "686c",
	"./2_.svg": "4fcf",
	"./31.svg": "6c55",
	"./32.svg": "c6a5",
	"./33.svg": "8a25",
	"./5.svg": "7b57",
	"./6.svg": "9575",
	"./7.svg": "6665",
	"./8.svg": "b2e1",
	"./lotto.svg": "84f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84a4";